import axiosInstance from '../auth/axiosInstance';

export const getAllProjects = async () => {
  try {
    const { data: result } = await axiosInstance.get('/Project/GetProjectList');

    if (result.data && Array.isArray(result.data)) {
      return result.data;
    }

    return [];
  } catch (error) {
    console.error('Error fetching all projects:', error);
    return [];
  }
};

export const getProjectList = async (companyId) => {
  try {
    console.log('Fetching project list...');

    const { data: result } = await axiosInstance.get(`/Company/${companyId}/Projects`);

    console.log('project list response:', result);

    if (result.data && Array.isArray(result.data)) {
      return result.data;
    }

    console.error('Unexpected response structure:', result);
    return [];
  } catch (error) {
    console.error('Error fetching projects:', error);
    return [];
  }
};

export const addOrUpdateProject = async (projectData) => {
  try {
    console.log('Adding/updating project with data:', projectData);
    const formattedData = {
      ...projectData,
    };

    console.log('Formatted data being sent to API:', formattedData);
    const { data: responseData } = await axiosInstance.post(
      '/Project/AddOrUpdateProject',
      formattedData
    );

    console.log('AddOrUpdateProject response:', responseData);
    if (responseData.data) {
      console.log('Returning project data:', responseData.data);
      return responseData.data;
    }

    console.error('Invalid response structure:', responseData);
    return {
      ...formattedData,
      id: formattedData.id || `temp-${Date.now()}`,
    };
  } catch (error) {
    console.error('Error during saving project:', error.message || error);
    throw error;
  }
};

export const deleteProject = async (projectId) => {
  const { data: responseData } = await axiosInstance.post(
    `/Project/DeleteProject/${projectId}`
  );

  const responseCode = responseData?.code ?? responseData?.Code;
  const failed =
    responseData?.data === false ||
    responseCode === 403 ||
    responseCode === 'Forbidden';

  if (failed) {
    const apiMessage = responseData?.message || responseData?.Message;
    throw new Error(apiMessage || 'Failed to delete project');
  }

  return responseData;
};
